import { render } from "./ModalStep.vue?vue&type=template&id=61becbdc&scoped=true"
import script from "./ModalStep.vue?vue&type=script&lang=js"
export * from "./ModalStep.vue?vue&type=script&lang=js"

import "./ModalStep.vue?vue&type=style&index=0&id=61becbdc&scoped=true&lang=css"
import "./ModalStep.vue?vue&type=style&index=1&id=61becbdc&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61becbdc"]])

export default __exports__